import * as React from "react";
import "./Title.scss";

interface TitleProps {
    title: string;
    nextToTitle?: JSX.Element;
    explanation?: string;
}

interface TitleState {
    explanationActive: boolean;
}

export class Title extends React.Component<TitleProps, TitleState> {
    constructor(props: TitleProps) {
        super(props);
        this.state = {
            explanationActive: false,
        };
        this.activateExplanation = this.activateExplanation.bind(this);
        this.deactivateExplanation = this.deactivateExplanation.bind(this);
    }

    public render() {
        let explanation = null;
        if (this.props.explanation != null && this.props.explanation !== "") {
            let allClassNames: string = "marketing-widget__explanation-text";
            if (this.state.explanationActive) {
                allClassNames += " active";
            }
            explanation = (
                <div
                    className="marketing-widget__explanation"
                    onMouseOver={this.activateExplanation}
                    onMouseOut={this.deactivateExplanation}
                >
                    <span>?</span>
                    <div className={allClassNames}>
                        <p>{this.props.explanation}</p>
                    </div>
                </div>
            );
        }
        return (
            <div className="marketing-widget__title">
                <div className={"flex flex-align-center flex-just-cont-space-between"}>
                    <h1 title={this.props.title}>{this.props.title}</h1>
                    {this.props.nextToTitle}
                </div>
                {explanation}
            </div>
        );
    }

    private activateExplanation() {
        this.setState({explanationActive: true});
    }

    private deactivateExplanation() {
        this.setState({explanationActive: false});
    }

}

interface SecondaryTitle {
    title: string;
}

export const SecondaryTitle: React.SFC<SecondaryTitle> = (props: SecondaryTitle) => {
    return (
        <div className="marketing-widget__secondary-title">
            <h2>{props.title}</h2>
        </div>
    );
};
